import {atom} from "recoil";

export const cateList = atom({
    key: 'cateList', // unique ID (with respect to other atoms/selectors)
    default: [''], // default value (aka initial value)

});